"use strict";
exports.__esModule = true;
exports.SOFT_CREDIT_CHECK_ERROR_MODAL_CONTENT = void 0;
exports.SOFT_CREDIT_CHECK_ERROR_MODAL_CONTENT = {
    DOB_AND_SOCIAL: 'Your date of birth and social security number must match the information you entered when you created your account.',
    INFO_MISMATCH: 'Information doesn’t match our records',
    UNABLE_TO_PROCESS: 'We were unable to process your application. Try again or ',
    REACH_OUT: 'reach out to our support team',
    FOR_ASSISTANCE: 'for assistance',
    SOMETHING_WENT_WRONG: 'Something went wrong'
};
